import { SignUpWithReferral } from '../components/auth/SignUpWithReferral/SignUpWithReferral';
export const SignUpWithReferrals = () => {
  return (
    <SignUpWithReferral />
  )
}